export enum MergeTypeEnum {
    SHIPMENTS = 'SHIPMENTS',
    DOCUMENTS = 'DOCUMENTS',
    INVOICES = 'INVOICES',
    PACKAGES = 'PACKAGES',
    PICKUPS = 'PICKUPS',
    BATCHES = 'BATCHES'
}
